import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { Controller } from "react-hook-form";
import { forwardRef } from "react";
import { Box, Card, CardContent, FormHelperText } from "@mui/material";

// Custom Radio Button
function BpRadio(props) {
  return <Radio disableRipple {...props} />;
}

const RowRadioButtonsGroup = forwardRef(
  ({ name, control, passValue, ...props }, ref) => {
    const EventCategoryType = [
      { value: 0, label: "Event" },
      { value: 1, label: "Meeting" },
    ];

    const EventHRDCorpGrant = [
      { value: 1, label: "Yes" },
      { value: 0, label: "No" },
    ];

    // Define EventFees safely
    const EventFees = passValue
      ? [
          {
            value: passValue.normal_rate,
            label: `NON-MEMBERS ${passValue.normal_rate} (SINGLE)`,
          },
          {
            value: passValue.group_discount_rate,
            label: `NON-MEMBERS ${passValue.group_discount_rate} (FOR GRP OF MIN.${passValue.min_group_discount_pax} PAX FROM THE SAME COMPANY)`,
          },
        ]
      : [];

    return (
      <Box sx={{ minWidth: 275 }}>
        <Card variant="outlined">
          <CardContent>
            <Controller
              name={name}
              control={control}
              defaultValue={""}
              rules={{ required: "Please select an option" }}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <FormControl sx={{ mt: 1 }} error={!!error}>
                  <RadioGroup
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    sx={{ mt: 1 }}
                    value={value}
                    onChange={onChange}
                  >
                    {["eventCategoryType"].includes(name) &&
                      EventCategoryType.map((option) => (
                        <FormControlLabel
                          key={option.value}
                          value={option.value}
                          control={<BpRadio />}
                          label={option.label}
                        />
                      ))}

                    {["eventFees"].includes(name) &&
                      passValue &&
                      EventFees.map((option, index) => (
                        <FormControlLabel
                          key={index}
                          value={option.value}
                          control={<BpRadio />}
                          label={option.label}
                        />
                      ))}

                    {["hrdCorpGrant"].includes(name) &&
                      EventHRDCorpGrant.map((option) => (
                        <FormControlLabel
                          key={option.value}
                          value={option.value}
                          control={<BpRadio />}
                          label={option.label}
                        />
                      ))}
                  </RadioGroup>
                  <FormHelperText>{error?.message}</FormHelperText>
                </FormControl>
              )}
            />
          </CardContent>
        </Card>
      </Box>
    );
  }
);

export default RowRadioButtonsGroup;
